import { LocalService } from './../../../services/storage/localService';
import { Component, OnInit, Injector } from "@angular/core";
import { FormGroup, FormControl, Validators, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { map, startWith } from "rxjs/operators";
import * as Inputmask from "inputmask";
import { DatePipe,DecimalPipe } from "@angular/common";
import {ErrorStateMatcher} from '@angular/material/core';
import {HttpErrorResponse } from '@angular/common/http';

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DocumentoNegociableService } from "../../../services/documento-negociable/documento-negociable.service";
import {SecurityService } from '../../../services/security/security.service'
import Swal  from "sweetalert2";
import { Router,ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { EmpresasService } from "../../../services/empresas/empresas.service";
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../models/messages';
import { LoginService } from "app/services/login/login.service";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: "app-factura-fisica",
  templateUrl: "./factura-fisica.component.html",
  styleUrls: ["./factura-fisica.component.css"],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,
    DatePipe,
    DecimalPipe,
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class FacturaFisicaComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  
  // DATOS DE LA RESPUESTA DEL DOCUMENTO NEGOCIABLE
  comprobante: any;

  // AUTOCOMPLETABLE DE PROVEEDORES
  filteredProveeedor: Observable<any[]>;

  // AUTOCOMPLETABLE DE ADQUIRENTES
  filteredAdquirente: Observable<any[]>;
 
  isLinear = false;

  // LONGITUD DEL ARREGLO DE CUOTAS
  longitud;

  // CONSTANTE DE MILISEGUNDOS POR DIA 
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

  // ARREGLO DE PROVEEDORES PARA EL AUTOCOMPELTABLE
  proveedoresArr;

  // ARREGLO DE ADQUIRENTES PARA EL AUTOCOMPELTABLE
  adquirentesArr;

  // PROVEEDOR OBTENIDO
  proveedor: any = {};

  // ADQUIRENTSE OBTENIDO
  adquirente: any = {};

  // VARIABLE DE ERROR DE PROV/ADQ OBTENIDO 
  error1: boolean = false;
  error: boolean = false;

  // VARIABLE DE LOADING
  loading: boolean = false;

  // VARIABLE DE MENSAJE DEL ERROR DE PROV/ADQ OBTENIDO
  mensaje1: string;
  mensaje2: string;
  retencionBaseElement : any;
  detraccionBaseElement : any;
  fondoGarantiaBaseElement :any;

  monedaElement : any;
  disable : boolean;
  form: FormGroup;
  formSended : FormGroup;
  cuotasform: FormGroup;
  unaCuota :FormGroup;

  titulo : string;
  comprobanteId: any; 
  update: boolean = false;
  action:string = "crear";
  usuario_com: any;
  // habilita el estado untouched de el error span del Input
  // tslint:disable-next-line: no-use-before-declare
  matcher = new MyErrorStateMatcher();

  rucProv = new FormControl();
  rucAdq = new FormControl();

  user: any;
  IGV_Porcentaje:any;
  negociabesService: DocumentoNegociableService;
  empresasService: EmpresasService;
  securityservice:SecurityService;
  loginService:LoginService;
  localService : LocalService;
  datePipe: DatePipe;
  router: Router;
  tipoUser:any;
  //Cuotas :any;
  constructor(
    private injector:Injector,
    private decimalPipe: DecimalPipe,
    private msgTitulos : MessagesTitles,
    private msgPersonalizados : MessagesGeneral,
    private msgFechasPersonalizados : MessagesDates,
    private activateRoute :ActivatedRoute,
    private messagesStatus:MessagesStatus,
    
  ) {
    this.negociabesService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.securityservice = this.injector.get<SecurityService>(SecurityService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.datePipe = this.injector.get<DatePipe>(DatePipe);
    this.router = this.injector.get<Router>(Router);
    this.IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    console.log("user",this.user);
    this.ObtenerAdquirentesCombo();
    this.ObtenerProveedoresCombo();
    
    this.cuotasform = new FormGroup({
     Cuotas: new FormArray([
        new FormGroup({
          Fecha_de_Pago: new FormControl("", Validators.required),
          Importe: new FormControl("", [Validators.required,Validators.pattern("^[0-9.,]+$")]),
        })
      ]),
      Estado: new FormControl("R", [])
    });

    this.longitud = this.cuotasform.controls["Cuotas"]["controls"].length;
    this.form = new FormGroup({
      IGVToggle: new FormControl(false, []),
      Tipo_Comprobante: new FormControl("F", [Validators.maxLength(1)]),
      Tipo_Emision: new FormControl("F", []),
      idProveedor: new FormControl("", []),
      idAdquirente: new FormControl("", []),
      archivo: new FormControl("", []),
      VNPP_ICLV: new FormControl("0.0", []),
      Alta_Fecha: new FormControl("", []),
      Alta_Usuario: new FormControl(this.user.Usuario, []),
      Usuario_Comercial: new FormControl("", []),
      Alta_Canal: new FormControl("W", []),
      Baja_Fecha: new FormControl(null, []),
      Baja_Usuario: new FormControl(null, []),
      Baja_Canal: new FormControl(null, []),

      rucAdquirente: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]{11}$")
      ]),

      razSocial: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      dirFiscal: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      departamento: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      provincia: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      distrito: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      // contacto: new FormControl("", [Validators.required,Validators.pattern("^[a-zA-Z]{3,50}$")]),
      // correo: new FormControl("", [Validators.required , Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-z]+\\.[a-z]{2,3}$')]),
      // telefono: new FormControl("", [Validators.required,Validators.pattern("^[0-9]{7,12}$")]),

      // proveedor
      rucProveedor: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]{11}$")
      ]),
      razSocialProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      dirFiscalProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      departamentoProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      provinciaProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      distritoProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      // contactoProveedor: new FormControl("", [Validators.required ]),
      // correoProveedor: new FormControl("", [Validators.required , Validators.pattern(this.emailPattern)]),
      // telefonoProveedor: new FormControl("", [Validators.required]),

      Autorizacion: new FormControl("", [
        Validators.required
        
      ]),
      Serie: new FormControl("0000", [
        Validators.required,
        Validators.pattern("^[0-9]{4}$")
      ]),
      Numero: new FormControl("",[Validators.required]),
      Fecha_Emision: new FormControl("", [Validators.required]),
      Moneda: new FormControl("", [Validators.required]),

      Descripcion: new FormControl("", [
        Validators.maxLength(100),
        Validators.required
      ]),
      Fecha_Vencimiento: new FormControl("", [Validators.required]),
      Fecha_Entrega: new FormControl("2025-01-01", [Validators.required]),
      // Fecha_Aceptacion: new FormControl("", []),
      // Fecha_Comunicacion: new FormControl("", []),
      VNPP: new FormControl("0.0", [Validators.required]),
      Total_Honorarios: new FormControl("0.0", []),
      Total_Recibido: new FormControl("0.0", []),
      Fecha_de_Pago: new FormControl("", [Validators.required]),
      cuotas: new FormControl(false, []),
      Tipo_Pago: new FormControl("C", []),
      Numero_Cuotas: new FormControl({ value: 1, disabled: true }, [
        Validators.maxLength(2)
      ]),

      Valor_Venta: new FormControl("0.00", [
        Validators.required,
        Validators.pattern("^[0-9.,]+$")
      ]),
      IGV_Importe: new FormControl({ value: "0.0", disabled: true }, [
        Validators.required
      ]),
      Precio_Venta: new FormControl("0.0", [
        Validators.required,
        Validators.pattern("^[0-9.,]+$")
      ]),
      // idGuia 35 : S = SI 
      IGV_Exonerado: new FormControl(35, []),
      IGV_Porcentaje: new FormControl(this.IGV_Porcentaje, []),
      Detraccion_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      Detraccion_Base: new FormControl(71, []),
      Detraccion_Importe: new FormControl(
        { value: "0.0", disabled: true },
        []
      ),
      Retencion_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      // idGuia 71 : P = Precio de venta
      Retencion_Base: new FormControl(71, []),
      Retencion_Importe: new FormControl({ value: "0.0", disabled: true }, []),
      Fondo_Garantia_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      // idGuia 72 : V = Valor de venta
      Fondo_Garantia_Base: new FormControl(72, []),
      Fondo_Garantia_Importe: new FormControl(
        { value: "0.0", disabled: true },
        [Validators.required, Validators.maxLength(1)]
      ),
      Ajustes: new FormControl({ value: "0.0", disabled: true }, []),
      Otros_Descuentos: new FormControl("0.0", [Validators.pattern("^[0-9.,]+$") ])

     
    });


    this.formSended = new FormGroup({
      // cuotas = new FormArray([]),
      IGVToggle: new FormControl(false, []),
      Tipo_Comprobante: new FormControl("F", [Validators.maxLength(1)]),
      Tipo_Emision: new FormControl("F", []),
      idProveedor: new FormControl("", []),
      idAdquirente: new FormControl("", []),
      archivo: new FormControl("", []),
      VNPP_ICLV: new FormControl("0.0", []),
      Alta_Fecha: new FormControl("", []),
      Alta_Usuario: new FormControl(this.user.Usuario, []),
      Usuario_Comercial: new FormControl("", []),
      Alta_Canal: new FormControl("W", []),
      Baja_Fecha: new FormControl(null, []),
      Baja_Usuario: new FormControl(null, []),
      Baja_Canal: new FormControl(null, []),

      rucAdquirente: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]{11}$")
      ]),

      razSocial: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      dirFiscal: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      departamento: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      provincia: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      distrito: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
    
      rucProveedor: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]{11}$")
      ]),
      razSocialProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      dirFiscalProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      departamentoProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      provinciaProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),
      distritoProveedor: new FormControl({ value: "", disabled: true }, [
        Validators.required
      ]),

      Autorizacion: new FormControl("", [
        Validators.required
        
      ]),
      Serie: new FormControl("0000", [
        Validators.required,
        Validators.pattern("^[0-9]{4}$")
      ]),
      Numero: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]{1,7}$")
      ]),
      Fecha_Emision: new FormControl("", [Validators.required]),
      Moneda: new FormControl("", [Validators.required]),

      Descripcion: new FormControl("", [
        Validators.maxLength(100),
        Validators.required
      ]),
      Fecha_Vencimiento: new FormControl("", [Validators.required]),
      Fecha_Entrega: new FormControl("2025-01-01", [Validators.required]),
      // Fecha_Aceptacion: new FormControl("", []),
      // Fecha_Comunicacion: new FormControl("", []),
      VNPP: new FormControl("0.0", [Validators.required]),
      Total_Honorarios: new FormControl("0.0", []),
      Total_Recibido: new FormControl("0.0", []),
      Fecha_de_Pago: new FormControl("", [Validators.required]),
      cuotas: new FormControl(false, []),
      Tipo_Pago: new FormControl("C", []),
      Numero_Cuotas: new FormControl({ value: 1, disabled: true }, [
        Validators.maxLength(2)
      ]),

      Valor_Venta: new FormControl("0.00", [
        Validators.required,
        Validators.pattern("^[0-9.,]+$")
      ]),
      IGV_Importe: new FormControl({ value: "0.0", disabled: true }, [
        Validators.required
      ]),
      Precio_Venta: new FormControl("0.0", [
        Validators.required,
        Validators.pattern("^[0-9.,]+$")
      ]),

      IGV_Exonerado: new FormControl(35, []),
      IGV_Porcentaje: new FormControl(this.IGV_Porcentaje, []),
      Detraccion_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      Detraccion_Base: new FormControl(71, []),
      Detraccion_Importe: new FormControl(
        { value: "0.0", disabled: true },
        []
      ),
      Retencion_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      Retencion_Base: new FormControl(71, []),
      Retencion_Importe: new FormControl({ value: "0.0", disabled: true }, []),
      Fondo_Garantia_Porcentaje: new FormControl('0.0', [Validators.required,Validators.pattern("^[0-9.,]+$")]),
      Fondo_Garantia_Base: new FormControl(72, []),
      Fondo_Garantia_Importe: new FormControl(
        { value: "0.0", disabled: true },
        [Validators.required, Validators.maxLength(1)]
      ),
      Ajustes: new FormControl({ value: "0.0", disabled: true }, []),
      Otros_Descuentos: new FormControl("0.0", [Validators.pattern("^[0-9.,]+$") ])

     
    });

  }

  ngOnInit() {
    Inputmask().mask(document.querySelectorAll("input"));
    this.titulo = "Registro de Factura Física";
    
    this.listarUsuariosComercial();

    this.activateRoute.params.subscribe( (params:Params):void => {      
      if(params['id'] != undefined){
        this.loading = true;
        this.action = params['action'];
        this.comprobanteId = params['id'];
        this.update = true;
        this.titulo = "Editar Factura Física";
        this.negociabesService.obtenerDocNegociablesById(this.comprobanteId)
        .subscribe(res => {
            this.loading = false;
            this.form.controls['Serie'].setValue(res[0]['Serie']);  
            this.form.controls['Numero'].setValue(res[0]['Numero']);  
            this.form.controls['Fecha_Emision'].setValue(res[0]['Fecha_Emision']);  
            this.rucProv.setValue(res[0]['Num_Doc_Identificacion']);
            this.form.controls['rucProveedor'].setValue(res[0]['Num_Doc_Identificacion']); 
            this.form.controls['idProveedor'].setValue(res[0]['idProveedor']); 
            this.form.controls['idAdquirente'].setValue(res[0]['idAdquirente']); 
            this.form.controls['razSocialProveedor'].setValue(res[0]['Razon_Social']); 
            this.form.controls['dirFiscalProveedor'].setValue(res[0]['Direccion_Fiscal']); 
            this.form.controls['departamentoProveedor'].setValue(res[0]['Departamento']); 
            this.form.controls['provinciaProveedor'].setValue(res[0]['Provincia']); 
            this.form.controls['distritoProveedor'].setValue(res[0]['Distrito']); 
            
            this.rucAdq.setValue(res[0]['Num_Doc_IdentificacionAdq']);             
            this.form.controls['rucAdquirente'].setValue(res[0]['Num_Doc_IdentificacionAdq']);            
            this.form.controls['razSocial'].setValue(res[0]['Razon_SocialAdq']); 
            this.form.controls['dirFiscal'].setValue(res[0]['Direccion_FiscalAdq']); 
            this.form.controls['departamento'].setValue(res[0]['departamentoAdq']); 
            this.form.controls['provincia'].setValue(res[0]['provinciaAdq']); 
            this.form.controls['distrito'].setValue(res[0]['distritoAdq']);
                        
            this.form.controls['Autorizacion'].setValue(res[0]['Autorizacion']);  
            this.form.controls['Moneda'].setValue(res[0]['Moneda']);  
            this.form.controls['Valor_Venta'].setValue(res[0]['Valor_Venta']);  
            this.form.controls['IGV_Importe'].setValue(res[0]['IGV_Importe']);  
            this.form.controls['IGVToggle'].setValue(res[0]['IGV_Exonerado']);  
            this.form.controls['Precio_Venta'].setValue(res[0]['Precio_Venta']); 

            this.form.controls['Descripcion'].setValue(res[0]['Descripcion']);  
            this.form.controls['Fecha_Entrega'].setValue(res[0]['Fecha_Entrega']);  
            this.form.controls['Fecha_Vencimiento'].setValue(res[0]['Fecha_Vencimiento']);  
            this.form.controls['Fecha_de_Pago'].setValue(res[0]['Fecha_de_Pago']);  
            this.form.controls['VNPP'].setValue(res[0]['VNPP']);
            this.form.controls['Usuario_Comercial'].setValue(res[0]['Usuario_Comercial']);
            if(res[0]['NroCuotas'] > 1){
              
              this.form.controls['cuotas'].setValue(true);              
              this.form.controls['Numero_Cuotas'].setValue(res[0]['NroCuotas']);                          
              this.longitud = res[0]['NroCuotas'];              
              for(let i = 0; i < res[0]['NroCuotas']; i++){
               
                this.agregarCuotas();
                
                this.cuotasform.controls["Cuotas"]["controls"][i]["controls"]["Fecha_de_Pago"].setValue(res["cuotas"][i]["Fecha_de_Pago"]);
                this.cuotasform.controls["Cuotas"]["controls"][i]["controls"]["Importe"].setValue(res["cuotas"][i]["Importe"]);
              }
            }
            this.form.controls['Detraccion_Porcentaje'].setValue(res[0]['Detraccion_Porcentaje'] * 100);  
            this.form.controls['Detraccion_Base'].setValue(71);  
            this.form.controls['Detraccion_Importe'].setValue(res[0]['Detraccion_Importe']);  
            this.form.controls['Retencion_Porcentaje'].setValue(res[0]['Retencion_Porcentaje'] *100);  
            this.form.controls['Retencion_Base'].setValue(res[0]['Retencion_Base']);  
            this.form.controls['Retencion_Importe'].setValue(res[0]['Retencion_Importe']);  
            this.form.controls['Fondo_Garantia_Porcentaje'].setValue(res[0]['Fondo_Garantia_Porcentaje']*100);  
            this.form.controls['Fondo_Garantia_Base'].setValue(res[0]['Fondo_Garantia_Base']);  
            this.form.controls['Fondo_Garantia_Importe'].setValue(res[0]['Fondo_Garantia_Importe']);  
            this.form.controls['Otros_Descuentos'].setValue(res[0]['Otros_Descuentos']);  
            this.form.controls['Ajustes'].setValue(res[0]['Ajustes']);
    
            this.monedaElement = res[0]['Moneda'] ;

            this.retencionBaseElement = res[0]['Retencion_Base'];
            this.detraccionBaseElement = 71;
            this.fondoGarantiaBaseElement = res[0]['Fondo_Garantia_Base'];
            
            if(this.action == "ver"){
              this.desactivarFormulario();
            }            
        },err => {
          this.loading = false;
        });
      }
    }) 
    this.retencionBaseElement = 71;
    this.detraccionBaseElement  = 71;
    this.fondoGarantiaBaseElement = 72;
    
  }

  tipoMoneda(event){
    this.form.controls['Moneda'].setValue(event);
    this.formSended.controls['Moneda'].setValue(event);
  }

  RetencionBase(event){
    this.form.controls['Retencion_Base'].setValue(event);
  }

  DetraccionBase(event){
    this.form.controls['Detraccion_Base'].setValue(event);
  }

  FondoGarantiaBase(event){
    this.form.controls['Fondo_Garantia_Base'].setValue(event);
  }

  listarUsuariosComercial(){
    let TipoUsuario = "COM";
    this.securityservice.ObtenerUsuarios(TipoUsuario).subscribe(res =>{
      console.log("usuarios",res)     
      this.usuario_com = res;
      this.usuario_com.map((item:any)=>
      {if(this.user.Email===item.Email){
        this.tipoUser=item.Nombre
        console.log("tipo usuario",this.tipoUser)
      }}
      )

    })
  }

  limpiarCampo(campoForm: string) {
    this.form.get(campoForm).setValue('');
    this.form.get(campoForm).reset();
  }

  desactivarFormulario(){
    this.form.disable();
    this.cuotasform.disable();
    this.disable = true;
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / this.MILISENGUNDOS_POR_DIA);
  }


  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirente = this.rucAdq.valueChanges.pipe(
      startWith(""),map(
        state => state ? this._filterAdq(state) : this.adquirentesArr.slice()
      )
    );
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.rucProv.valueChanges.pipe(
      startWith(""),map(
        state => state ? this._filterProv(state) : this.proveedoresArr.slice()
      )
    );
  }

  ObtenerEmpresasCombo() {
    this.empresasService.obtenerProveedores().subscribe(res => {
      this.proveedoresArr = res;
      this.filteredProveeedor = this.form.controls["rucProveedor"].valueChanges.pipe(
        startWith(""),map( 
          state => state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
    });
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.proveedoresArr.filter( state => state.Razon_Social.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.adquirentesArr.filter( state => state.Razon_Social.toLowerCase().indexOf(filterValue) === 0);
  }

  deshabilitarIGV() {
    let valorVenta = this.cortarComa(this.form.get("Valor_Venta").value);
    let IGV = valorVenta * this.IGV_Porcentaje;

    if (this.form.controls["IGVToggle"].value == false) {

      let precioVenta = Number(valorVenta);

      this.form.get("IGV_Importe").setValue(0.0);
      this.form.get("Precio_Venta").setValue(precioVenta.toFixed(2));
    } else {

      let precioVenta = Number(valorVenta) + Number(IGV);

      this.form.get("IGV_Importe").setValue(IGV.toFixed(2));
      this.form.get("Precio_Venta").setValue(precioVenta.toFixed(2));
    }
  }

  calcularDetraccion() {
    let porcentajeDetraccion = this.cortarComa(
      this.form.controls["Detraccion_Porcentaje"].value
    );
    
    let valorBaseDetraccion = this.form.controls["Detraccion_Base"].value;

    if(valorBaseDetraccion == 72){
      let VV = this.cortarComa(this.form.controls["Valor_Venta"].value);    
      let descuentoVV = Number((VV * porcentajeDetraccion) / 100);       
      this.form.controls["Detraccion_Importe"].setValue(descuentoVV);
    }else{
      let PV = this.cortarComa(this.form.controls["Precio_Venta"].value);
      let descuentoPV = Number((PV * porcentajeDetraccion) / 100);
      this.form.controls["Detraccion_Importe"].setValue(descuentoPV);
    }
  }

  calcularRetencion() {
    let porcentajeDetraccion = this.cortarComa(
      this.form.controls["Retencion_Porcentaje"].value
    );
    let valorBaseDetraccion = this.form.controls["Retencion_Base"].value;

    if(valorBaseDetraccion == 72){
      let VV = this.cortarComa(this.form.controls["Valor_Venta"].value);
        let descuentoVV = (VV * porcentajeDetraccion) / 100;
        this.form.controls["Retencion_Importe"].setValue(descuentoVV);
    }else{
      let PV = this.cortarComa(this.form.controls["Precio_Venta"].value);
        let descuentoPV = (PV * porcentajeDetraccion) / 100;
        this.form.controls["Retencion_Importe"].setValue(descuentoPV);
    }
  }

  calcularFonfoGarantia() {
    let porcentajeDetraccion = this.cortarComa(
      this.form.controls["Fondo_Garantia_Porcentaje"].value
    );
    let valorBaseDetraccion = this.form.controls["Fondo_Garantia_Base"].value;

    if(valorBaseDetraccion == 72){
      let VV = this.cortarComa(this.form.controls["Valor_Venta"].value);
      let descuentoVV = (VV * porcentajeDetraccion) / 100;
      this.form.controls["Fondo_Garantia_Importe"].setValue(descuentoVV);
    }else{
      let PV = this.cortarComa(this.form.controls["Precio_Venta"].value);
      let descuentoPV = (PV * porcentajeDetraccion) / 100;
      this.form.controls["Fondo_Garantia_Importe"].setValue(descuentoPV);
    }
  }


  transformarDatosParaEnviar() {

      this.formSended.setValue(this.form.getRawValue());

      if (this.formSended.controls["Usuario_Comercial"].value == "") {
        this.formSended.controls["Usuario_Comercial"].setValue(this.user.Usuario);
      }
    if (this.formSended.controls["cuotas"].value == false) {
      this.formSended.controls["Numero_Cuotas"].setValue(0);
    }

    this.formSended.controls["Alta_Fecha"].setValue(
      this.datePipe.transform(Date(), "yyyy-MM-dd  HH:mm:ss")
    );

    this.formSended.controls["Fecha_Vencimiento"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_Vencimiento"].value,
        "yyyy-MM-dd"
      )
    );

    this.formSended.controls["Fecha_Entrega"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_Entrega"].value,
        "yyyy-MM-dd"
      )
    );

    this.formSended.controls["Fecha_de_Pago"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_de_Pago"].value,
        "yyyy-MM-dd"
      )
    );

    this.formSended.controls["Fecha_Emision"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_Emision"].value,
        "yyyy-MM-dd"
      )
    );

    if (this.formSended.controls["cuotas"].value == true) {
      this.formSended.controls["Tipo_Pago"].setValue("C");
      this.formSended.controls["Numero_Cuotas"].setValue(
        this.cuotasform.controls["Cuotas"]["controls"].length
      );
    } else {
      this.formSended.controls["Tipo_Pago"].setValue("U");
      this.formSended.controls["Numero_Cuotas"].setValue(1);
    }

    if(this.formSended.controls["IGVToggle"].value == true){
      this.formSended.controls["IGV_Exonerado"].setValue(35);
    }else{
      this.formSended.controls["IGV_Exonerado"].setValue(36);
    }


    const percent = 100;

    let det = this.formSended.controls["Detraccion_Porcentaje"].value / percent;
    this.formSended.controls["Detraccion_Porcentaje"].setValue(det);

    let ret = this.formSended.controls["Retencion_Porcentaje"].value / percent;
    this.formSended.controls["Retencion_Porcentaje"].setValue(ret);

    let garant =
    this.formSended.controls["Fondo_Garantia_Porcentaje"].value / percent;
    this.formSended.controls["Fondo_Garantia_Porcentaje"].setValue(garant);

    this.formSended.controls["Valor_Venta"].setValue(
      this.cortarComa(this.formSended.controls["Valor_Venta"].value)
    );
    this.formSended.controls["Precio_Venta"].setValue(
      this.cortarComa(this.formSended.controls["Precio_Venta"].value)
    );
    this.formSended.controls["IGV_Importe"].setValue(
      this.cortarComa(this.formSended.controls["IGV_Importe"].value)
    );
    this.formSended.controls["VNPP"].setValue(
      this.cortarComa(this.formSended.controls["VNPP"].value)
    );
    this.formSended.controls["Total_Honorarios"].setValue(
      this.formSended.controls["VNPP"].value    
    );
    this.formSended.controls["Total_Recibido"].setValue(
      this.formSended.controls["VNPP"].value    
    );
    this.formSended.controls["VNPP_ICLV"].setValue(
      this.cortarComa(this.formSended.controls["VNPP"].value)
    );

    this.formSended.controls["Detraccion_Importe"].setValue(
      this.cortarComa(this.formSended.controls["Detraccion_Importe"].value)
    );
    this.formSended.controls["Retencion_Importe"].setValue(
      this.cortarComa(this.formSended.controls["Retencion_Importe"].value)
    );
    this.formSended.controls["Fondo_Garantia_Importe"].setValue(
      this.cortarComa(this.formSended.controls["Fondo_Garantia_Importe"].value)
    );

    this.formSended.controls["Otros_Descuentos"].setValue(
      this.cortarComa(this.formSended.controls["Otros_Descuentos"].value)
    );
  }

  guardarCambios() {
    this.validar();
       
          // VALIDACION DE LA FECHA DE PAGO CON LA ULTIMA FECHA DE LA CUOTA
    if (this.form.controls['cuotas'].value){
          let ultimaCuota = this.longitud-1;
          let ultimaFechaCuota = this.cuotasform.controls["Cuotas"]["controls"][ultimaCuota]["controls"]["Fecha_de_Pago"].value;
          
          if (this.datePipe.transform(this.form.controls["Fecha_de_Pago"].value,'yyyy-MM-dd') != this.datePipe.transform(ultimaFechaCuota,'yyyy-MM-dd')) {
            Swal.fire({
              title: "ERROR",
              text: "La Fecha de la última cuota no puede ser diferente que la Fecha de Pago",
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          }
      
          // VALIDACION DE LA SUMA DEL IMPORTE DE LAS CUOTAS SEA IGUAL AL VNPP
      
          let pagos : any = 0;
      
          for (let index = 0; index < this.longitud; index++) {
            let p  = this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value);
              
            pagos += Number(p);
          }
          
          if (pagos != this.cortarComa(this.form.controls['VNPP'].value)) {
            Swal.fire({
              title: "Error",
              text: "La suma de las cuotas es diferente al VNPP",
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          }

          // METODO NUEVO - FALTA PROBAR

          for (let index = 0; index < this.longitud; index++) {
              
            if (  this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Fecha_de_Pago"].value > this.form.controls["Fecha_de_Pago"].value) {

              Swal.fire({
                title: "Error",
                text: "La Fecha de las cuotas no puede ser mayor a la Fecha de Pago",
                type: "warning",
                allowOutsideClick: true,
                heightAuto: false
              });
                return;
            }
          }
        }
    Swal.fire({
      title: "Espere",
      text: "Guardado Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    try {
      
      this.transformarDatosParaEnviar();
      this.transformarImporteCuotas();
            
      if(this.update){
        this.editar();
      }else{
        this.crear();
      }
    } catch (error) {
      console.log(error);
      this.mensaje1 = "Error al guardar Documento Negociable - Llamar a Soporte";
      Swal.fire({
      title: "ERROR GRAVE",
        text: this.mensaje1,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });

      }
  }

  crear(){
    this.negociabesService
        .crearDocNegociable(this.formSended.getRawValue())
        .subscribe(
          data => {
            this.comprobante = data;
            let idComprobante = this.comprobante["idComprobante"];
            this.mensaje1 = "Documento Registrado Correctamente";
            if (this.form.controls["cuotas"].value == true) {
              this.transformarFechas();
              this.negociabesService
                .crearCuotas(this.cuotasform.getRawValue(), idComprobante)
                .subscribe(
                  (res:object) => {
                    Swal.fire({
                      title: "Success",
                      text: "Documento Registrado Correctamente",
                      type: "success",
                      allowOutsideClick: false,
                      heightAuto: false
                    }).then(resp2 => {
                      if (resp2.value == true) {
                        this.goBack();
                      }
                    });
                  },
                  (err: HttpErrorResponse)=> {
                    this.messagesStatus.getMessage(err.status);           
                    Swal.fire({
                      title: "ERROR",
                      text: "NO SE PUDO GUARDAR CUOTAS. "+this.messagesStatus.message,
                      type: "error",
                      allowOutsideClick: false,
                      heightAuto: false
                    });
                  }
                );
            } else {

              let FP = this.formSended.controls['Fecha_de_Pago'].value;
    
              this.unaCuota = new FormGroup({
                Cuotas: new FormArray([
                  new FormGroup({
                    Fecha_de_Pago: new FormControl(FP),
                    Importe: new FormControl(this.formSended.controls['VNPP'].value, []),
                    Importe_Ejecutado: new FormControl(0, []),
                    Importe_Pendiente: new FormControl(this.formSended.controls['VNPP'].value, [])
                  }),
                 ]),
                Estado: new FormControl("R", [])
              });


              this.negociabesService
              .crearCuotas(this.unaCuota.getRawValue(), idComprobante)
              .subscribe(
                res1 => {
                  Swal.fire({
                    title: "Success",
                    text: "Documento Registrado Correctamente",
                    type: "success",
                    allowOutsideClick: false,
                    heightAuto: false
                  }).then(resp3 => {
                    if (resp3.value == true) {
                      this.goBack();
                    }
                  });
                },
                (err1: HttpErrorResponse)=> {
                  this.messagesStatus.getMessage(err1.status);  
                  Swal.fire({
                    title: "ERROR",
                    text: "NO SE PUDO GUARDAR CUOTAS. "+ this.messagesStatus.message,
                    type: "error",
                    allowOutsideClick: false,
                    heightAuto: false
                  });
                }
              );
            }
          },
          (err: HttpErrorResponse)=> {
            let errorMessage = "";
            errorMessage = err.error.message;
            this.messagesStatus.getMessage(err.status);
            for (let index = 0; index < this.longitud; index++) {
              this.tranformarDecimalCuotas(index,'Importe');
              
            }
            Swal.fire({
              title: this.msgTitulos.Error_Leve,       
              text: errorMessage,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );
  }

  editar(){
    this.negociabesService
        .actualizarDocNegociable(this.formSended.getRawValue(),this.comprobanteId)
        .subscribe(
          data => {
            this.comprobante = data;
            this.mensaje1 = "Documento actualizado correctamente"; 
            if (this.form.controls["cuotas"].value == true) {
              this.transformarFechas();
              this.negociabesService
                .crearCuotas(this.cuotasform.getRawValue(), this.comprobanteId)
                
                .subscribe(
                  res => {
                    Swal.fire({
                      title: "Success",
                      text: "Documento Registrado Correctamente.",
                      type: "success",
                      allowOutsideClick: false,
                      heightAuto: false
                    }).then(resp => {
                      if (resp.value == true) {
                        this.goBack();
                      }
                    });
                  },
                  (err: HttpErrorResponse)=> {
                    this.messagesStatus.getMessage(err.status);  
                    Swal.fire({
                      title: "Error",
                      text: "CUOTA NO REGISTRADA. "+this.messagesStatus.message,
                      type: "error",
                      allowOutsideClick: false,
                      heightAuto: false
                    });
                  }
                );
            } else {
              let FP = this.formSended.controls['Fecha_de_Pago'].value;
              this.unaCuota = new FormGroup({
                Cuotas: new FormArray([
                  new FormGroup({
                    Fecha_de_Pago: new FormControl(FP),
                    Importe: new FormControl(this.formSended.controls['VNPP'].value, []),
                    Importe_Ejecutado: new FormControl(0, []),
                    Importe_Pendiente: new FormControl(this.formSended.controls['VNPP'].value, [])
                  }),
                 ]),
                Estado: new FormControl("R", [])
              });
              this.negociabesService
              .crearCuotas(this.unaCuota.getRawValue(), this.comprobanteId)
              .subscribe(
                res => {
                  Swal.fire({
                    title: "Success",
                    text: "Documento Registrado Correctamente",
                    type: "success",
                    allowOutsideClick: false,
                    heightAuto: false
                  }).then(resp1 => {
                    if (resp1.value == true) {
                      this.goBack();
                    }
                  });
                },
                (err: HttpErrorResponse)=> {
                  this.messagesStatus.getMessage(err.status);         
                  Swal.fire({
                    title: "ERROR",
                    text: "CUOTA NO REGISTRADA. "+ this.messagesStatus.message,
                    type: "error",
                    allowOutsideClick: false,
                    heightAuto: false
                  });
                }
              );
            }
          },
          (err: HttpErrorResponse)=> {
            this.messagesStatus.getMessage(err.status);     
            for (let index = 0; index < this.longitud; index++) {
              this.tranformarDecimalCuotas(index,'Importe');
            }
            Swal.fire({
              title: this.msgTitulos.Error_Leve,
              text:"ERROR AL ACTUALIZAR. " +this.messagesStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );
  }
  validar(){
    if(this.error1){
      Swal.fire({
        title: "Algo salio mal!",
        text: "Proveedor bloqueado.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if(this.error){
      Swal.fire({
        title: "Algo salio mal!",
        text: "Adquirente bloqueado.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if (this.form.invalid) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgPersonalizados.Error_Campos_Vacios,
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (Math.abs(this.form.controls["Ajustes"].value) > 2) {
      Swal.fire({
        title: this.msgTitulos.Error_Algo_Salio_Mal,
        text: this.msgPersonalizados.Error_Ajuste_Alto,
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    let fechaEmision = this.datePipe.transform(
      this.form.controls["Fecha_Emision"].value,
      "yyyy-MM-dd"
    );

    sessionStorage.setItem(
      "FechaEmit",
      this.form.controls["Fecha_Emision"].value
    );
    let fechaHoyUSD = new Date();
    let fechaEmiDif = new Date(this.form.controls["Fecha_Emision"].value);

    let diferencia6Meses = this.diferenciaEntreDiasEnDias(
      fechaHoyUSD,
      fechaEmiDif
    );

    if (Math.abs(diferencia6Meses) > 365) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Fecha_Emision_menor_6_Meses,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    let fechaHoy = this.datePipe.transform(Date(), "yyyy-MM-dd");

    if (
      this.form.controls["Fecha_Emision"].value >
      this.form.controls["Fecha_Vencimiento"].value
    ) {
      alert("La fecha de Emision no puede ser mayor a la de vencimiento");
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Emision_mayor_Vencimiento,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      this.form.controls["Fecha_Vencimiento"].value >
      this.form.controls["Fecha_de_Pago"].value
    ) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Pago_menor_Vencimiento,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      this.datePipe.transform(
        this.form.controls["Fecha_de_Pago"].value,
        "yyyy-MM-dd"
      ) < fechaHoy
    ) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Pago_menor_Actual,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      this.datePipe.transform(
        this.form.controls["Fecha_Vencimiento"].value,
        "yyyy-MM-dd"
      ) < fechaHoy
    ) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Vencimiento_menor_Actual,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      fechaEmision >
      this.datePipe.transform(
        this.form.controls["Fecha_Entrega"].value,
        "yyyy-MM-dd"
      )
    ) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Entrega_menor_Emision,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    /* ESTA FECHA DEBE SER EDITADA DESDE LA BASE DE DATOS PARA QUE PUEDA VALIDARSE CORRECTAMENTE*/

    if (
      this.datePipe.transform(
        this.form.controls["Fecha_Entrega"].value,
        "yyyy-MM-dd"
      ) > fechaHoy
    ) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Entrega_mayor_Actual,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if (fechaEmision > fechaHoy) {
      Swal.fire({
        title: this.msgTitulos.Error_Invalido,
        text: this.msgFechasPersonalizados.Error_Emision_mayor_Actual,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      
    }  
  }
  validarCuotas(termino?: string) {
    console.log( 'cuotas',this.cuotasform.controls["Cuotas"]["controls"])
    if(this.form.controls["cuotas"].value == true){
      this.form.controls["Numero_Cuotas"].setValue(
        this.cuotasform.controls["Cuotas"]["controls"].length
      );
    }else{
      this.form.controls["Numero_Cuotas"].setValue(1);
    }

  }

  validarProveedor(idProveedor: string , serie :string) {
    if (this.rucProv.invalid) {
      return;
    }
    if (this.rucProv.value == "") {
      Swal.fire({
        title: "error",
        text: "Por favor ingresa un RUC",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    this.proveedor = {};
     
    this.form.get("razSocialProveedor").setValue("");
    this.form.get("dirFiscalProveedor").setValue("");
    this.form.get("departamentoProveedor").setValue("");
    this.form.get("provinciaProveedor").setValue("");
    this.form.get("distritoProveedor").setValue("");

    this.loading = true;
    this.negociabesService.validarEmpresaExistente(idProveedor,serie ).subscribe(
      data => {
        if (data == null) {
          this.error1 = true;
          this.mensaje1 = "Proveedor no encontrado.";
          this.loading = false;
        } else {

          this.proveedor = data;

          if(this.proveedor.Estado == "X" ){
            this.error1 = true;
            this.mensaje1 = "Proveedor bloqueado.";
            this.loading = false;
            return;
          }

          this.error1 = false;
          this.form.controls["rucProveedor"].setValue(this.proveedor.Num_Doc_Identificacion);

          this.form.controls["idProveedor"].setValue(this.proveedor.idEmpresa);

          this.form.controls["razSocialProveedor"].setValue(
            this.proveedor.Razon_Social
          );

          this.form.controls["dirFiscalProveedor"].setValue(
            this.proveedor.Direccion_Fiscal
          );

          this.form.controls["departamentoProveedor"].setValue(
            this.proveedor.Departamento
          );

          this.form.controls["provinciaProveedor"].setValue(
            this.proveedor.Provincia
          );

          this.form.controls["distritoProveedor"].setValue(
            this.proveedor.Distrito
          );
          this.form.controls["Autorizacion"].setValue(
            this.proveedor.Autorizacion
          );
          this.loading = false;
        }
      },
      error => {
        let message;
        if(error.status == 0){
          message = "Servicio caído, contactarse con el área de soporte.";
        }else{
          message = "Ocurrió un error. Por favor contactarse con el área de soporte.";
        }
        Swal.fire({
          title: "Error",
          text: message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        }).then(rpta =>{
          this.loading = false;
        });
      }
    );
  }

  validarAdquirente(ruc: string) {
    if (this.rucAdq.invalid) {
      Swal.fire({
        title: "error",
        text: "Por favor ingresa un RUC válido",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (this.rucAdq.value == "") {
      Swal.fire({
        title: "error",
        text: "Por favor ingresa un RUC",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    this.adquirente = {};

    this.form.get("razSocial").setValue("");
    this.form.get("dirFiscal").setValue("");
    this.form.get("departamento").setValue("");
    this.form.get("provincia").setValue("");
    this.form.get("distrito").setValue("");


    this.loading = true;
    this.negociabesService.validarEmpresaExistenteADQ(ruc).subscribe(
      data => {
        if (data == null) {
          this.error = true; 
          this.mensaje2 = "Adquirente no encontrado.";
          this.loading = false;

        } else {
          this.adquirente = data;
          this.loading = false;

          if(this.adquirente.Estado == "X" ){
            this.error = true;
            this.mensaje2 = "Adquirente bloqueado.";
            return;
          }

          this.form.controls["rucAdquirente"].setValue(
            this.adquirente.Num_Doc_Identificacion
          );
          this.form.controls["idAdquirente"].setValue(
            this.adquirente.idEmpresa
          );

          this.form.controls["razSocial"].setValue(
            this.adquirente.Razon_Social
          );

          this.form.controls["dirFiscal"].setValue(
            this.adquirente.Direccion_Fiscal
          );

          this.form.controls["departamento"].setValue(
            this.adquirente.Departamento
          );

          this.form.controls["provincia"].setValue(this.adquirente.Provincia);

          this.form.controls["distrito"].setValue(this.adquirente.Distrito);
          (this.error = false)
        }
      },
    );
  }

  alerta(valor?) {
    alert("cambio el valor");
  }

  calcularAjuste() {
    let precioVenta = this.cortarComa(this.form.controls["Precio_Venta"].value);
    let VNPP = this.cortarComa(this.form.controls["VNPP"].value);
    let detraccionImporte = this.cortarComa(
      this.form.controls["Detraccion_Importe"].value
    );
    let retencionImporte = this.cortarComa(
      this.form.controls["Retencion_Importe"].value
    );
    let garantiaImporte = this.cortarComa(
      this.form.controls["Fondo_Garantia_Importe"].value
    );
    let otrosDescuentos = this.cortarComa(
      this.form.controls["Otros_Descuentos"].value
    );

    let VNPPmenosPV = Number(VNPP - precioVenta);

    let sumaImportes =
      Number(detraccionImporte) +
      Number(retencionImporte) +
      Number(garantiaImporte) +
      Number(otrosDescuentos);

    let ajuste = Number(VNPPmenosPV - -sumaImportes);

    this.form.controls["Ajustes"].setValue(ajuste.toFixed(2));
  }

  agregarCuotas() {
    console.log('longitud',this.cuotasform.controls["Cuotas"].value)
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;
    this.cuotasform.controls["Cuotas"]["controls"].push(
      new FormGroup({
        Fecha_de_Pago: new FormControl("", Validators.required),
        Importe: new FormControl("", [
          Validators.required,
          Validators.pattern("^^[0-9.,]+$")
        ])
      })
    );

    this.form.controls["Numero_Cuotas"].setValue(cantidad + 1);
    this.longitud = this.cuotasform.controls["Cuotas"]["controls"].length;
  }

  eliminarCuotas() {
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;
    (<FormArray> this.cuotasform.controls["Cuotas"]).removeAt(cantidad - 1);

    this.form.controls["Numero_Cuotas"].setValue(cantidad - 1);
    this.longitud = this.cuotasform.controls["Cuotas"]["controls"].length;
  }

  transformarFechas() {
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;

    for (let index = 0; index <= cantidad - 1; index++) {
     
      this.cuotasform.controls["Cuotas"]["controls"][index]["controls"][
        "Fecha_de_Pago"
      ].setValue(
        this.datePipe.transform(
          this.cuotasform.controls["Cuotas"]["controls"][index]["controls"][
            "Fecha_de_Pago"
          ].value,
          "yyyy-MM-dd"
        )
      );
    }
  }

  transformarImporteCuotas() {
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;
    for (let index = 0; index <= cantidad - 1; index++) {
      this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].setValue(this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value));
    }
  }

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
    if (decimal) {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.form.controls[`${control}`].value),
        `1.${decimal}-${decimal}`
      );
    } else {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.form.controls[`${control}`].value),
        `1.2-2`
      );
    }
    this.form.controls[`${control}`].setValue(valor);
  }

  tranformarDecimalCuotas(indice: number, control: any, decimal?: number) {
    let valor;
    if (decimal) {
      valor = this.decimalPipe.transform(
        this.cortarComa(
          this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
            `${control}`
          ].value
        ),
        `1.${decimal}-${decimal}`
      );
    } else {
      valor = this.decimalPipe.transform(
        this.cortarComa(
          this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
            `${control}`
          ].value
        ),
        `1.2-2`
      );
    }

    this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
      `${control}`
    ].setValue(valor);
  }

  cortarComa(numero: any): number {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }

  goBack(){
    this.loginService.clickGuard = true;
    this.router.navigate(["/negociables/factura/listado"]);
   }
}



export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}